export default __webpack_public_path__ + "static/media/noti-fi.f6b3a0f6.svg";